import { render, staticRenderFns } from "./Magic_panel.vue?vue&type=template&id=33dea4d4&scoped=true&"
import script from "./Magic_panel.vue?vue&type=script&lang=js&"
export * from "./Magic_panel.vue?vue&type=script&lang=js&"
import style0 from "./Magic_panel.vue?vue&type=style&index=0&id=33dea4d4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dea4d4",
  null
  
)

component.options.__file = "Magic_panel.vue"
export default component.exports